import ReactGA from 'react-ga';

import { GOOGLE_ANALYTICS_ENABLED } from '~/externalServices/serviceFlags';

if (GOOGLE_ANALYTICS_ENABLED) ReactGA.initialize('UA-57461303-2');
